var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('UpdateDialog',_vm._b({},'UpdateDialog',_vm.update_dialog,false,true))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }